/*
 *
 * AttractionsPage actions
 *
 */

const SCOPE = 'app/AttractionsPage/';
export const ActionTypes = {
    SET_PARAMS: `${SCOPE}SET_PARAMS`,
    SET_QUERY: `${SCOPE}SET_QUERY`,
    SET_IS_404: `${SCOPE}SET_IS_404`,

    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    SET_PAGE_PAGE: `${SCOPE}SET_PAGE_PAGE`,
    SET_PAGE_TOTAL: `${SCOPE}SET_PAGE_TOTAL`,
    SET_PAGE_HAS_MORE: `${SCOPE}SET_PAGE_HAS_MORE`,
    SET_PAGE_PRELOADED: `${SCOPE}SET_PAGE_PRELOADED`,
    SET_PAGE_IS_PRELOADED_VISIBLE: `${SCOPE}SET_PAGE_IS_PRELOADED_VISIBLE`,
    RESET_PAGE: `${SCOPE}RESET_PAGE`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_RECOMMENDS_IS_LOADED: `${SCOPE}SET_RECOMMENDS_IS_LOADED`,
    RESET_RECOMMENDS: `${SCOPE}RESET_RECOMMENDS`,
    FETCH_RECOMMENDS: `${SCOPE}FETCH_RECOMMENDS`,
    FETCH_RECOMMENDS_STARTED: `${SCOPE}FETCH_RECOMMENDS_STARTED`,
    FETCH_RECOMMENDS_SUCCESSFULLY: `${SCOPE}FETCH_RECOMMENDS_SUCCESSFULLY`,
    FETCH_RECOMMENDS_FAILED: `${SCOPE}FETCH_RECOMMENDS_FAILED`,
    FETCH_RECOMMENDS_CANCELLED: `${SCOPE}FETCH_RECOMMENDS_CANCELLED`,

    SET_FEATURED_CATEGORIES_IS_LOADED: `${SCOPE}SET_FEATURED_CATEGORIES_IS_LOADED`,
    RESET_FEATURED_CATEGORIES: `${SCOPE}RESET_FEATURED_CATEGORIES`,
    FETCH_FEATURED_CATEGORIES: `${SCOPE}FETCH_FEATURED_CATEGORIES`,
    FETCH_FEATURED_CATEGORIES_STARTED: `${SCOPE}FETCH_FEATURED_CATEGORIES_STARTED`,
    FETCH_FEATURED_CATEGORIES_SUCCESSFULLY: `${SCOPE}FETCH_FEATURED_CATEGORIES_SUCCESSFULLY`,
    FETCH_FEATURED_CATEGORIES_FAILED: `${SCOPE}FETCH_FEATURED_CATEGORIES_FAILED`,
    FETCH_FEATURED_CATEGORIES_CANCELLED: `${SCOPE}FETCH_FEATURED_CATEGORIES_CANCELLED`,

    SET_USER_IMAGES_IS_LOADED: `${SCOPE}SET_USER_IMAGES_IS_LOADED`,
    FETCH_USER_IMAGES_STARTED: `${SCOPE}FETCH_USER_IMAGES_STARTED`,
    FETCH_USER_IMAGES_SUCCESSFULLY: `${SCOPE}FETCH_USER_IMAGES_SUCCESSFULLY`,
    FETCH_USER_IMAGES_FAILED: `${SCOPE}FETCH_USER_IMAGES_FAILED`,
    FETCH_USER_IMAGES_CANCELLED: `${SCOPE}FETCH_USER_IMAGES_CANCELLED`,
};

/**
 * Common
 */
export const setIs404 = (is404) => ({
    type: ActionTypes.SET_IS_404,
    is404,
});

export const setParams = (params) => ({
    type: ActionTypes.SET_PARAMS,
    params,
});

export const setQuery = (query) => ({
    type: ActionTypes.SET_QUERY,
    query,
});

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const setPagePage = (page) => ({ type: ActionTypes.SET_PAGE_PAGE, page });
export const setPageTotal = (total) => ({ type: ActionTypes.SET_PAGE_TOTAL, total });
export const setPageHasMore = (hasMore) => ({ type: ActionTypes.SET_PAGE_HAS_MORE, hasMore });
export const setPageIsPreloadedVisible = (isPreloadedVisible) => ({
    type: ActionTypes.SET_PAGE_IS_PRELOADED_VISIBLE,
    isPreloadedVisible,
});
export const setPagePreloaded = (preloaded) => ({
    type: ActionTypes.SET_PAGE_PRELOADED,
    preloaded,
});
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const resetPage = () => ({ type: ActionTypes.RESET_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (activities) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    activities,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Recommends
 */
export const setRecommendsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_RECOMMENDS_IS_LOADED,
    isLoaded,
});
export const fetchRecommends = () => ({ type: ActionTypes.FETCH_RECOMMENDS });
export const resetRecommends = () => ({ type: ActionTypes.RESET_RECOMMENDS });
export const fetchRecommendsStarted = () => ({ type: ActionTypes.FETCH_RECOMMENDS_STARTED });
export const fetchRecommendsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_RECOMMENDS_SUCCESSFULLY,
    res,
});
export const fetchRecommendsFailed = (error) => ({
    type: ActionTypes.FETCH_RECOMMENDS_FAILED,
    error,
});
export const fetchRecommendsCancelled = () => ({
    type: ActionTypes.FETCH_RECOMMENDS_CANCELLED,
});

/**
 * FeaturedCategories
 */
export const setFeaturedCategoriesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_FEATURED_CATEGORIES_IS_LOADED,
    isLoaded,
});
export const fetchFeaturedCategories = () => ({ type: ActionTypes.FETCH_FEATURED_CATEGORIES });
export const resetFeaturedCategories = () => ({ type: ActionTypes.RESET_FEATURED_CATEGORIES });
export const fetchFeaturedCategoriesStarted = () => ({
    type: ActionTypes.FETCH_FEATURED_CATEGORIES_STARTED,
});
export const fetchFeaturedCategoriesSuccessfully = (categories) => ({
    type: ActionTypes.FETCH_FEATURED_CATEGORIES_SUCCESSFULLY,
    categories,
});
export const fetchFeaturedCategoriesFailed = (error) => ({
    type: ActionTypes.FETCH_FEATURED_CATEGORIES_FAILED,
    error,
});
export const fetchFeaturedCategoriesCancelled = () => ({
    type: ActionTypes.FETCH_FEATURED_CATEGORIES_CANCELLED,
});

/**
 * UserImages
 */
export const setUserImagesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_USER_IMAGES_IS_LOADED,
    isLoaded,
});
export const fetchUserImagesStarted = () => ({ type: ActionTypes.FETCH_USER_IMAGES_STARTED });
export const fetchUserImagesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_USER_IMAGES_SUCCESSFULLY,
    res,
});
export const fetchUserImagesFailed = (error) => ({
    type: ActionTypes.FETCH_USER_IMAGES_FAILED,
    error,
});
export const fetchUserImagesCancelled = () => ({
    type: ActionTypes.FETCH_USER_IMAGES_CANCELLED,
});
